import { useEffect, useState, useContext, useRef } from "react";
import styled from "styled-components";
import { DataContext } from "../context/DataContext";

const MatrixMultiple = ({
  setOtherErrors,
  questionsLength,
  question,
  index,
  answeredQuestions,
  setAnsweredQuestions,
  setCurrentPageAnswers,
  currentPage,
  errors,
  setErrors,
  toDisplay,
  parseDynamicQuestionText,
}) => {
  const [hovered, setHovered] = useState(false);
  const [bgColor, setBgColor] = useState("#f0fcfc");

  const { wrapperWidth } = useContext(DataContext);

  const handleMouseEnter = () => setHovered(true);
  const handleMouseLeave = () => setHovered(false);

  const [hoveredInput, setHoveredInput] = useState(null);

   

  useEffect(() => {
    if (index % 2 === 0) {
      setBgColor("#f0fcfc");
    } else {
      setBgColor("white");
    }
  }, [index]);

  useEffect(() => {
    let answeredQuestionsCopy = [...answeredQuestions];

    if (toDisplay && answeredQuestionsCopy[currentPage - 1][index]?.length) {
      if (typeof answeredQuestionsCopy[currentPage - 1][index] !== "object") {
        answeredQuestionsCopy[currentPage - 1][index] = question.Answers.map(
          (questionObj) => answeredQuestionsCopy[currentPage - 1].find(ans => typeof ans === 'string' && ans.split('=')[0] === questionObj.Expression.split('=')[0])
        )
      }

      answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[currentPage - 1].filter(question => typeof question === 'object')
      setAnsweredQuestions(answeredQuestionsCopy);
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
    } else {

      answeredQuestionsCopy[currentPage - 1][index] = question.Answers.map(
        (questionObj) => `${questionObj.AnswerCode}=0`
      );
      setAnsweredQuestions(answeredQuestionsCopy);
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
    }
  }, [currentPage]);

  const chooseAnswer = (event, index, answerIndex, responsive) => {
    let checkedCurrently = responsive
      ? !event.currentTarget.checked
      : event.currentTarget.firstChild.firstChild.firstChild.checked;
    let answeredQuestionsCopy = [...answeredQuestions];
    let none = question.Answers[answerIndex].AnswerType === "None";


    if (none) {
      if (answeredQuestionsCopy[currentPage - 1][index]) {
        answeredQuestionsCopy[currentPage - 1][index] = [
          ...answeredQuestions[currentPage - 1][index]
            .map((ansExpression) =>
              ansExpression
                .split("=")[0]
                .includes(`${question.Answers[0].Expression.split("_1=")[0]}_`)
                ? ansExpression.replace("=1", "=0")
                : ansExpression
            )
            .filter(
              (ans) =>
                ans.split("=")[0] !==
                question.Answers[answerIndex].Expression.split("=")[0]
            ),
          `${
            checkedCurrently
              ? `${question.Answers[answerIndex].Expression.replace(
                  "=1",
                  "=0"
                )}`
              : question.Answers[answerIndex].Expression
          }`,
        ];
      } else {
        answeredQuestionsCopy[currentPage - 1][index] = [];

        answeredQuestionsCopy[currentPage - 1][index].push(
          question.Answers[answerIndex].Expression
        );
      }
    } else {
      if (answeredQuestionsCopy[currentPage - 1][index]) {
        answeredQuestionsCopy[currentPage - 1][index] = [
          ...answeredQuestions[currentPage - 1][index]
            .map((ansExpression) =>
              ansExpression.split("=")[0] ===
                question.Answers[answerIndex].Expression.split("=")[0] ||
              question.Answers[
                question.Answers.findIndex((ansObj) =>
                  ansObj.AnswerLabel.includes("None")
                )
              ].Expression.split("=")[0] === ansExpression.split("=")[0]
                ? ansExpression.replace("=1", "=0")
                : ansExpression
            )
            .filter(
              (ans) =>
                ans.split("=")[0] !==
                question.Answers[answerIndex].Expression.split("=")[0]
            ),
          `${
            checkedCurrently
              ? `${question.Answers[answerIndex].Expression.replace(
                  "=1",
                  "=0"
                )}`
              : question.Answers[answerIndex].Expression
          }`,
        ];
      } else {
        answeredQuestionsCopy[currentPage - 1][index] = [];

        answeredQuestionsCopy[currentPage - 1][index].push(
          question.Answers[answerIndex].Expression
        );
      }
    }
    setAnsweredQuestions(answeredQuestionsCopy);
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);

    setOtherErrors([]);

    let errorsCopy = [...errors];

    if (checkedCurrently) {
      errorsCopy.push(question.Answers[answerIndex].Expression);
    } else {
      errorsCopy = !none
        ? errorsCopy.filter(
            (error) => error !== question.Answers[answerIndex].Expression
          )
        : errorsCopy.filter(
            (error) =>
              !error.includes(
                `${question.Answers[0].Expression.split("_1=")[0]}_`
              )
          );
    }
    setErrors(
      errorsCopy
    );
  };

  const spanRef = useRef(null); // Ref for BodyTh

  const [height, setHeight] = useState(null); // State to hold BodyTh height

  useEffect(() => {
    if (spanRef.current) {
      const thHeight = spanRef.current.offsetHeight;
      setHeight(thHeight);
    }
  }, []);

  useEffect(() => {
    if (spanRef.current) {
      setHeight(spanRef.current.offsetHeight);
    }
  }, [`${spanRef?.current?.offsetHeight}`]);

  window.addEventListener("resize", () => {
    if (spanRef.current) {
      setHeight(spanRef.current.offsetHeight);
    }
  });

  useEffect(() => {
    if (spanRef.current) {
      setHeight(spanRef.current.offsetHeight);
    }
  }, [currentPage]);

  return (
    <>
      {index === 0
        ? question.MatrixQuestionContext && (
            <p>{question.MatrixQuestionContext}</p>
          )
        : null}
      {index === 0 ? (
        <StyledH2
          dangerouslySetInnerHTML={{
            __html: question.QuestionHead
              ? parseDynamicQuestionText(question.QuestionHead, true)
              : question.QuestionName
              ? parseDynamicQuestionText(question.QuestionName, true)
              : null,
          }}></StyledH2>
      ) : null}
      <Wrapper>
        {index % 4 === 0 ? (
          <THead>
            <TR wrapperWidth={wrapperWidth}>
              {question.QuestionType !== "SingleRank" && (
                <TH $firstLeft={index === 0} $width="20%"></TH>
              )}
              {question.Answers.map((questionAnswers, i) => (
                <TH
                  $firstRight={i === question.Answers.length - 1}
                  $width={`${
                    question.QuestionType !== "SingleRank"
                      ? 80 / question.Answers.length
                      : 100 / question.Answers.length
                  }%`}>{`${
                  question.QuestionType === "MatrixRange"
                    ? i === 0
                      ? "1 - "
                      : i === 3
                      ? "4 - "
                      : i === 6
                      ? "7 - "
                      : ""
                    : question.QuestionType === "SingleRank"
                    ? i === 0
                      ? "1 - "
                      : i === question.Answers.length - 1
                      ? `${i + 1} - `
                      : ""
                    : ""
                }${questionAnswers.AnswerLabel}`}</TH>
              ))}
            </TR>
          </THead>
        ) : null}
        {parseDynamicQuestionText(question.QuestionName, true) &&
          parseDynamicQuestionText(question.QuestionName, true) !== "undefined" && (
            <TBody $height={height < 60 ? "62px" : `${height}px`}>
              <HoverBody
                $hovered={hovered}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                $bottomShadow={index === questionsLength - 1}
                $height={height < 60 ? "62px" : `${height}px`}
              />
              <TR
                wrapperWidth={wrapperWidth}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}>
                {question.QuestionType !== "SingleRank" && (
                  <BodyTh
                    $width="20%"
                    $bg={bgColor}
                    $color={"black"}
                    $weight={"400"}
                    $height={height < 60 ? "62px" : `${height}px`}
                    $bottomLeft={index === questionsLength - 1}>
                    <StyledSpan
                      dangerouslySetInnerHTML={{
                        __html: parseDynamicQuestionText(
                          question.QuestionName,
                          true
                        ),
                      }}
                      $errors={errors}
                      $question={question}
                      ref={spanRef}></StyledSpan>
                  </BodyTh>
                )}
                {question.Answers.map((answer, answerIndex) => (
                  <TD
                    $width={`${
                      question.QuestionType !== "SingleRank"
                        ? 80 / question.Answers.length
                        : 100 / question.Answers.length
                    }%`}
                    $bg={bgColor}
                    $height={height < 60 ? "62px" : `${height}px`}
                    onClick={(e) => {
                      e.preventDefault();
                      chooseAnswer(e, index, answerIndex);
                    }}>
                    <StyledLabel
                      checked={answeredQuestions[currentPage - 1][
                        index
                      ]?.includes(answer.Expression)}
                      id={`QAns${
                        answer.AnswerCode.split("A")[1]
                      }_${answerIndex}`}
                      onMouseEnter={() => setHoveredInput(answerIndex)}
                      onMouseLeave={() => setHoveredInput(null)}>
                      <CheckboxLabel>
                        <input
                          id={`QAns${
                            answer.AnswerCode.split("A")[1]
                          }_${answerIndex}`}
                          type="checkbox"
                          checked={answeredQuestions[currentPage - 1][
                            index
                          ]?.includes(answer.Expression)}
                          name={`question_${answer.AnswerCode.split("A")[1]}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            chooseAnswer(e, index, answerIndex);
                          }}
                        />
                      </CheckboxLabel>
                      <span></span>
                    </StyledLabel>
                    {hoveredInput === answerIndex && (
                      <ToolTip>{answer.AnswerLabel}</ToolTip>
                    )}
                  </TD>
                ))}
              </TR>
            </TBody>
          )}
      </Wrapper>

      <WrapperSmall>
        <TbodySmall>
          <TrSmall>
            <ThSmall $errors={errors} $question={question}>
              <StyledSpan
                dangerouslySetInnerHTML={{
                  __html: parseDynamicQuestionText(question.QuestionName, true),
                }}
                $errors={errors}
                $question={question}></StyledSpan>
            </ThSmall>
            {question.Answers.map((answer, answerIndex) => (
              <TdSmall
                key={answerIndex}
                $bg={answerIndex % 2 === 0 ? "#f0f4f4" : "transparent"}>
                <StyledLabel
                  checked={answeredQuestions[currentPage - 1][index]?.includes(
                    answer.Expression
                  )}
                  id={`QAns${answer.AnswerCode.split("A")[1]}_${answerIndex}`}>
                  <CheckboxLabelSmall
                    htmlFor={`small_QAns${
                      answer.AnswerCode.split("A")[1]
                    }_${answerIndex}`}>
                    <input
                      id={`small_QAns${
                        answer.AnswerCode.split("A")[1]
                      }_${answerIndex}`}
                      type="checkbox"
                      checked={answeredQuestions[currentPage - 1][
                        index
                      ]?.includes(answer.Expression)}
                      name={`question_${question.QuestionNo}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        chooseAnswer(e, index, answerIndex, true);
                      }}
                    />
                  </CheckboxLabelSmall>
                  <span></span>
                </StyledLabel>
                <Option errors={errors}>{`${
                  question.QuestionType === "MatrixRange"
                    ? answerIndex === 0
                      ? "1 - "
                      : answerIndex === 3
                      ? "4 - "
                      : answerIndex === 6
                      ? "7 - "
                      : ""
                    : question.QuestionType === "SingleRank"
                    ? answerIndex === 0
                      ? "1 - "
                      : answerIndex === question.Answers.length - 1
                      ? `${answerIndex + 1} - `
                      : ""
                    : ""
                }${answer.AnswerLabel}`}</Option>
                {hoveredInput === answerIndex && (
                  <ToolTipSmall>{answer.AnswerLabel}</ToolTipSmall>
                )}
              </TdSmall>
            ))}
          </TrSmall>
        </TbodySmall>
      </WrapperSmall>
    </>
  );
};

const StyledH2 = styled.h2`
  color: ${(props) =>
    props?.$errors?.includes(props?.$question?.QuestionCode) ||
    props?.$errors?.includes(props?.$question?.Answers[0].AnswerCode)
      ? "#ED1C24"
      : "#555"};
`;

const Wrapper = styled.div`
  @media (max-width: 760px) {
    display: none;
  }
`;

const WrapperSmall = styled.table`
  @media (min-width: 760px) {
    display: none;
  }

  width: 100%;
  max-width: 760px;
`;

const HoverBody = styled.div`
  width: 100%;
  height: ${(props) => props.$height};
  background-color: ${({ $hovered }) => ($hovered ? "#d8f4f4" : "transparent")};
  ${(props) =>
    props.$bottomShadow && "box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);"}
  position: absolute;
  z-index: 0;
`;

const THead = styled.thead`
  width: 950px;
  height: 62px;
`;

const TBody = styled.tbody`
  width: 950px;
  height: ${(props) => props.$height};
  height: 62px;
  background-color: #d8f4f4;
  position: relative;
`;

const TR = styled.tr`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: ${(props) => props.wrapperWidth};
`;

const TH = styled.th`
  width: ${(props) => props.$width};
  height: 92px;
  background-color: #5bc5cd;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 2px solid #d5f0f2;
  ${(props) => props.$firstLeft && "border-radius: 4px 0 0 0;"}
  ${(props) => props.$firstRight && "border-radius: 0 4px 0 0;"}
`;

const BodyTh = styled.th`
  width: ${(props) => props.$width};
  height: ${(props) => props.$height};
  background-color: ${(props) => (props.$bg ? props.$bg : "white")};
  color: black;
  font-weight: 400;
  display: flex;
  align-items: center;
  border-right: 2px solid #d5f0f2;

  span {
    padding: 10px;
    z-index: 2;
  }
  ${(props) => props.$bottomLeft && "border-radius: 0 0 0 6px;"}
`;

const TD = styled.td`
  width: ${(props) => props.$width};
  height: ${(props) => props.$height};
  background-color: ${(props) => (props.$bg ? props.$bg : "white")};
  display: flex;
  justify-content: center;
  border-right: 2px solid #d5f0f2;
  ${(props) => props.$bottomRight && "border-radius: 0 0 6px 0;"}
`;

const StyledLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;

  input {
    opacity: 0;
    position: absolute;
    cursor: pointer;
  }

  span {
    width: 20px;
    height: 20px;
    border: 2px solid #5bc5cd;
    display: inline-block;
    position: relative;
    background-color: white;
    z-index: 2;
    color: #5bc5cd;
    font-weight: 800;
  }

  span::after {
    content: "✓";
    width: 10px;
    height: 10px;
    // background-color: #5bc5cd;
    // border-radius: 50%;
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  ${(props) =>
    props.checked &&
    `span::after {
    opacity: 1;
  }`}
`;

const CheckboxLabel = styled.label`
  height: 64px;
  width: 154px;
  position: absolute;
  cursor: pointer;
`;

const CheckboxLabelSmall = styled.label`
  height: 60px;
  width: 760px;
  position: absolute;
  cursor: pointer;
  left: -20px;
`;

const TbodySmall = styled.tbody`
  width: 100%;
  max-width: 760px;
`;
const ThSmall = styled.th`
  height: 40px;
  width: 100%;
  background-color: #5bc5cd;
  display: flex;
  align-items: center;
  span {
    color: ${(props) =>
      props?.$errors.filter((errorCode) =>
        errorCode.includes(
          `${props?.$question?.Answers[0].Expression.split("_1=")[0]}_`
        )
      ).length === props?.$question?.Answers.length
        ? "#ED1C24"
        : "white"};
    font-weight: 600;
    padding-left: 10px;
  }
`;

const TdSmall = styled.td`
  height: 60px;
  background-color: ${(props) => (props.$bg ? props.$bg : "white")};
  display: flex;
  align-items: center;
  padding: 0px 20px;
  margin: 2px;
  width: 760px;

  &:hover {
    background-color: #e8edf3;
  }
`;

const TrSmall = styled.tr`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  background-color: #e8edf3;
  margin-bottom: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
`;

const Option = styled.span`
  margin-left: 20px;
`;

const StyledSpan = styled.span`
  color: ${(props) =>
    // props?.$errors?.includes(props?.$question?.QuestionCode) ||
    props?.$errors.filter((errorCode) =>
      errorCode.includes(
        `${props?.$question?.Answers[0].Expression.split("_1=")[0]}_`
      )
    ).length === props?.$question?.Answers.length
      ? "#ED1C24"
      : "#555"};
  text-align: left;
`;

const ToolTip = styled.div`
  position: absolute;
  background-color: #f58233;
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
  top: -10px;
`;

const ToolTipSmall = styled.div`
  position: relative;
  background-color: #f58233;
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
  left: 200px;
`;
export default MatrixMultiple;
